import {
  createNewSearchAgent,
  deleteSearchAgent,
  fetchCurrentOrganizationAgents,
  patchSearchAgent,
} from '@/actions/searchAgents';
import { getUserAccessToken } from '@/utils/account/getUserAccessToken';

export const fetchOrganizationAgents = async (organizationId: string) => {
  const userAccessToken = await getUserAccessToken();
  return fetchCurrentOrganizationAgents(userAccessToken, organizationId);
};

export interface CreateSearchAgentParams {
  name: string;
  searchQueryId: string;
  recipientIds: string[];
  interval: string;
  notificationsEnabled: boolean;
  enabled?: boolean;
  minScore: number;
}

export interface PatchSearchAgentParams {
  name: string;
  recipientIds: string[];
  interval: string;
  notificationsEnabled: boolean;
  enabled?: boolean;
  minScore: number;
}

export const createSearchAgent = async (searchAgent: CreateSearchAgentParams) => {
  const userAccessToken = await getUserAccessToken();
  return createNewSearchAgent(userAccessToken, searchAgent);
};

export const removeSearchAgent = async (agentId: string) => {
  const userAccessToken = await getUserAccessToken();
  return deleteSearchAgent(userAccessToken, agentId);
};

export const editSearchAgent = async (agentId: string, searchAgent: PatchSearchAgentParams) => {
  const userAccessToken = await getUserAccessToken();
  return patchSearchAgent(userAccessToken, agentId, searchAgent);
};
